import { AccessMatrixRoleConfiguration, LookupListItem } from '../../api/user/model';
import { GET_ACCESS_ROLE_URL } from '../../constants/apiUrls';
import { GET_ACCESS_ROLE_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================
interface GetAccessRoleResponse {
  accessMatrixConfiguration: AccessMatrixRoleConfiguration[];
  modules: LookupListItem[];
  roles: LookupListItem[];
}

// =============================================================================
// Query
// =============================================================================
export const useGetAccessRole = () => {
  const getAccessRole = async () => {
    const res = await axiosClient.get<GetAccessRoleResponse>(GET_ACCESS_ROLE_URL);

    return res.data;
  };

  return useCustomQuery(GET_ACCESS_ROLE_QUERY_KEY, getAccessRole);
};
